// @flow

// We're using window.performance
/* eslint-disable no-restricted-globals */

import * as React from 'react';
import { trackEventAJAXOnPageOnce } from '@ta/common.tracking';

// timing labels
const measureMVPHeroLoad = 'mvp-hero-load';
// start of hero placement
const mvpStartMark = 'mvp-hero-start';
// proxy hero image load
const mvpImgLoad = 'mvp-img-load';

// Measure and GARecord results
const perfMeasure = () => {
  const pf = window.performance;
  /* eslint-disable no-unused-expressions */
  pf.measure && pf.measure(measureMVPHeroLoad, mvpStartMark, mvpImgLoad);

  // log the latency
  const entry = pf.getEntriesByName && pf.getEntriesByName(measureMVPHeroLoad)[0];
  const latency = entry ? parseInt(entry.duration, 10) : -1;
  const trackingProps = {
    module: 'mvp_hero',
    action: 'hero_latency',
    context: 'from_mvp_start',
    value: latency,
  };
  trackEventAJAXOnPageOnce(trackingProps);
};

const perfMark = markLabel => {
  const pf = window.performance;
  if (pf && pf.mark) {
    pf.mark(markLabel);
  }
};

export const getLatencyTracker = (heroUrl: string) => {
  // Not you, server
  if (typeof window !== 'undefined') {
    perfMark(mvpStartMark);
    // Queue the logging
    window.setTimeout(perfMeasure, 3000);
  }
  // Track the latency on image load
  const onLoadFn = `var pf=window.performance;pf.mark&&pf.mark('${mvpImgLoad}');`;
  // The dangerous! innerHTML
  const tracker = `<img data-owner="hero_latency_tracker" src="${heroUrl}" height="1" width="1" onload="${onLoadFn}" style="position:absolute;left:0;top:0;opacity:0">`;
  // eslint-disable-next-line react/no-danger
  return <div dangerouslySetInnerHTML={{ __html: tracker }} />;
};

export { getLatencyTracker as default };
